import './Loader.css';

// ==============================|| LOADER ||============================== //
const Loader = () => (
    <div className="gd-loader" role="progressbar" aria-label="Loading">
        <div className="gd-loader__bar" />
    </div>
);

export default Loader;
